import React from 'react';
import CalenderScheduleDescription from '../../../components/organism/CalenderScheduleDescription';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const InfoCard = (props) => {
  return (
    <CalenderScheduleDescription {...props} />
  )
};

export default withSitecoreContext()(InfoCard);
